var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurrentPlace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82332 2.00373C8.25115 1.90141 10.25 3.91989 10.25 6.42453C10.25 7.24033 10.0343 8.0022 9.66429 8.65844C9.66417 8.65955 9.66427 8.66067 9.66436 8.66176C9.66447 8.6631 9.66458 8.66441 9.66429 8.66563C8.86688 10.079 6.84917 12.6041 6.2029 13.4017C6.09665 13.5328 5.90327 13.5328 5.79702 13.4017C5.15075 12.6041 3.13304 10.079 2.33563 8.66563C2.3355 8.66453 2.33556 8.66337 2.33563 8.66217C2.33569 8.66095 2.33576 8.65969 2.33563 8.65844C1.91541 7.91288 1.69414 7.03099 1.76214 6.08853C1.92178 3.87702 3.69485 2.09333 5.82332 2.00373ZM6 7.5C6.69036 7.5 7.25 6.94036 7.25 6.25C7.25 5.55964 6.69036 5 6 5C5.30964 5 4.75 5.55964 4.75 6.25C4.75 6.94036 5.30964 7.5 6 7.5Z",
    fill: "#262D39",
    fillOpacity: 0.52
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentPlace);
export default __webpack_public_path__ + "static/media/current_place.ac96c7d849e48d3bb40f726e38cf9787.svg";
export { ForwardRef as ReactComponent };